var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGradient1",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9C27B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4CAF50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGradient2",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#81C784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGradient3",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3F51B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#66BB6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGradient4",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4CAF50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGradient5",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#81C784"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10             L85 30             L85 70             L50 90             L15 70             L15 30 Z",
    fill: "none",
    stroke: "#455A64",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2194F3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 30,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 5,
    height: 40,
    fill: "url(#barGradient1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "15;40;25;35;15",
    dur: "3.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "25;0;15;5;25",
    dur: "3.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 5,
    height: 40,
    fill: "url(#barGradient2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "30;20;40;15;30",
    dur: "3.7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "10;20;0;25;10",
    dur: "3.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 5,
    height: 40,
    fill: "url(#barGradient3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "20;35;15;40;20",
    dur: "3.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "20;5;25;0;20",
    dur: "3.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 5,
    height: 40,
    fill: "url(#barGradient4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "35;15;30;20;35",
    dur: "3.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "5;25;10;20;5",
    dur: "3.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 5,
    height: 40,
    fill: "url(#barGradient5)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "25;40;20;35;25",
    dur: "3.4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "15;0;20;5;15",
    dur: "3.4s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeActivity);
export default __webpack_public_path__ + "static/media/node_activity.eb08e66b14b8033389f4efca4bd2b8bb.svg";
export { ForwardRef as ReactComponent };